import { AnimatePresence, motion } from "framer-motion";
import { PageMeta } from "./PageMeta";
import { useEffect, useState, lazy, Suspense } from "react";
import type { ReactNode } from "react";

const HeroBelowFold = lazy(() => import("./HeroBelowFold"));

// import logo from "@/assets/Final Logo-1.png";
// import logoDark from "@/assets/Final Logo-2.png";
// import logoLight from "@/assets/small-size.png";
// import logoDarkSmall from "@/assets/small-size-wht.png";
// import { PopupModal } from "react-calendly";
import {
  ArrowRight,
  MessageCircle,
  CalendarDays,
  ArrowUpRight,
} from "lucide-react";
import { FaLinkedin, FaTwitter, FaGithub, FaYoutube } from "react-icons/fa";
import { Link } from "react-router-dom";
import heroVideo from "@/assets/Hero.mp4";
import { cn } from "@/lib/utils";

export default function Hero() {

  // const servicess = [
  //   { label: "Enterprise AI", href: "#enterprise-ai" },
  //   { label: "Industrial IoT", href: "#iot" },
  //   { label: "Product Engineering", href: "#product" },
  //   { label: "Enterprise Systems", href: "#cloud" },
  //   { label: "Engineering Team", href: "#data" },
  // ];

  // const industriess = [
  //   { label: "Healthcare", href: "#healthcare" },
  //   { label: "Manufacturing", href: "#manufacturing" },
  //   { label: "Finance", href: "#finance" },
  //   { label: "Logistics", href: "#energy" },
  //   { label: "Retail", href: "#retail" },
  // ];



  const trust = [
    "19+ Years Experience",
    "650+ Global Clients",
    "15+ Countries Served",
    "2.5K+ Applications Delivered",
    "38+ Engineers & Specialists",
  ];

  const words = [
    "Enterprise Software",
    "AI Solution",
    "Cloud Services",
    "Digital Transformation",
    "Global Business"
  ];

  const [index, setIndex] = useState(0);


  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % words.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  // const [open, setOpen] = useState(false);

  const openCalendly = () => {
    window.open(
      "https://calendly.com/santhiladatabot/30min",
      "_blank"
    );
  };

  const openWhatsApp = () => {
    window.open(
      "https://wa.me/7373070033",
      "_blank"
    );
  };

  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkDesktop = () => setIsDesktop(window.innerWidth >= 768);
    checkDesktop();
    window.addEventListener("resize", checkDesktop);
    return () => window.removeEventListener("resize", checkDesktop);
  }, []);

  return (
    <>
      <PageMeta
        title="Santhila DataBot - Your Global Technology Partner for AI, SaaS & Enterprise Software"
        description="Santhila DataBot builds advanced Enterprise AI solutions, secure RAG pipelines, and Industrial IoT platforms for scaling corporations across the USA & Australia."
        path="/"
      />


      {/* <PopupModal
        url="https://calendly.com/santhiladatabot/30min"
        open={open}
        onModalClose={() => setOpen(false)}
        rootElement={document.body}
      /> */}

      {/* HERO SECTION */}
      <section className={cn('hero-section', 'overflow-x-hidden', 'relative', 'isolate', 'overflow-hidden', 'pb-24', 'pt-36', 'md:pt-40')} >
        {isDesktop && (
          <video
            src={heroVideo}
            autoPlay
            loop
            muted
            playsInline
            className={cn('absolute', 'hidden', 'md:block', 'inset-0', '-z-20', 'h-full', 'w-full', 'object-cover', 'opacity-75')}
          />
        )}
        <div
          className={cn('absolute', 'inset-0', '-z-10', 'bg-black/40')}
          style={{
            backgroundImage:
              "radial-gradient(1200px 600px at 90% -10%, var(--color-hero-to), transparent 60%), linear-gradient(to top, color-mix(in oklab, var(--color-hero-from) 60%, transparent), var(--color-background))",
          }}
        />
        <div className={cn('mx-auto', 'max-w-6xl', 'px-6')}>
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className={cn('mt-5', 'md:mt-8', 'mb-5', 'text-xs', 'font-semibold', 'uppercase', 'tracking-[0.25em]', 'text-heading')}
          >
            Santhila DataBot
          </motion.p>

          {/* <motion.h1
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className={cn('hero-title', 'max-w-full', 'xl:max-w-7xl', 'font-sans', 'text-4xl', 'font-bold', 'md:leading-[1.05]', 'md:tracking-[-0.03em]', 'md:text-5xl', 'lg:text-6xl', 'xl:text-[70px]')}
          >
            <span className="text-foreground">
              <span className="block">AI - Powered </span>
              <span className="block">
                Technology Partner for{" "}
                <br />
                <AnimatePresence mode="wait">
                  <motion.span
                    key={words[index]}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                    className={cn('inline-flex', 'text-brand')}
                  >
                    {words[index].split("").map((char, i) => (
                      <motion.span
                        key={i}
                        variants={{
                          hidden: {
                            opacity: 0,
                            y: 20,
                            filter: "blur(4px)",
                          },
                          visible: {
                            opacity: 1,
                            y: 0,
                            filter: "blur(0px)",
                          },
                          exit: {
                            opacity: 0,
                            y: -20,
                            filter: "blur(4px)",
                          },
                        }}
                        transition={{
                          duration: 0.20,
                          delay: i * 0.07,
                        }}
                        className="inline-block"
                      >
                        {char === " " ? "\u00A0" : char}
                      </motion.span>
                    ))}
                  </motion.span>
                </AnimatePresence>
              </span>
            </span>{" "}

          </motion.h1> */}

          <h1
            className={cn(
              "hero-title",
              "max-w-full",
              "font-sans",
              "font-bold",
              "tracking-[-0.025em]",

              // Mobile
              "text-[34px]",
              "leading-[1.15]",

              // Tablet and desktop
              "md:text-5xl",
              "md:leading-[1.05]",
              "md:tracking-[-0.03em]",
              "lg:text-6xl",
              "xl:max-w-7xl",
              "xl:text-[70px]"
            )}
          >
            {/* Mobile heading */}
            <span className="block md:hidden">
              {/* Small top label */}
              <div className="mb-2 flex items-center gap-3">
                <span className="h-px w-8 bg-brand" />

                <span className="text-[18px] font-bold uppercase tracking-[0.040em] text-foreground">
                  AI Powered
                </span>
              </div>

              {/* Main heading */}
              <span className="block text-[40px] font-bold leading-[0.9] tracking-[-0.05em] text-foreground">
                Technology
              </span>

              {/* Supporting line */}
              <span className="mt-2 block text-[26px] font-semibold leading-none tracking-[-0.030em] text-foreground/70">
                Partner for
              </span>

              {/* Animated branded block */}
              <div className="mt-3 w-full">
                <AnimatePresence initial={false} mode="wait">
                  <motion.span
                    key={words[index]}
                    initial={{
                      opacity: 0,
                      x: -20,
                    }}
                    animate={{
                      opacity: 1,
                      x: 0,
                    }}
                    exit={{
                      opacity: 0,
                      x: 20,
                    }}
                    transition={{
                      duration: 0.35,
                      ease: "easeOut",
                    }}
                    className="block text-[32px] font-bold leading-[0.8] tracking-[-0.035em] text-brand"
                  >
                    {words[index]}
                  </motion.span>
                </AnimatePresence>
              </div>
            </span>

            {/* Tablet and desktop heading */}
            <span className="hidden text-foreground md:block md:leading-[1]">
              <span className="block">AI - Powered</span>

              <span className="block">
                Technology Partner for
              </span>

              <span className="block min-h-[1em] text-brand">
                <AnimatePresence initial={false} mode="wait">
                  <motion.span
                    key={words[index]}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                    className="inline-flex"
                  >
                    {words[index].split("").map((char, i) => (
                      <motion.span
                        key={`${words[index]}-desktop-${i}`}
                        variants={{
                          hidden: {
                            opacity: 0,
                            y: 20,
                            filter: "blur(4px)",
                          },
                          visible: {
                            opacity: 1,
                            y: 0,
                            filter: "blur(0px)",
                          },
                          exit: {
                            opacity: 0,
                            y: -20,
                            filter: "blur(4px)",
                          },
                        }}
                        transition={{
                          duration: 0.2,
                          delay: i * 0.07,
                        }}
                        className="inline-block"
                      >
                        {char === " " ? "\u00A0" : char}
                      </motion.span>
                    ))}
                  </motion.span>
                </AnimatePresence>
              </span>
            </span>
          </h1>

          <p
            className={cn('hero-description', 'mt-10', 'md:mt-4', 'max-w-xl', 'text-[1rem]', 'text-foreground/75', 'md:text-[18px]')}
          >
            Santhila's credibility through key milestones including 19+ years of experience, 650+ Global clients, 15+ countries served, and over 2.5k+ successful project deliveries
          </p>

          <motion.div
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.25 }}
            className={cn('hero-buttons', 'mt-[2.2rem]', 'lg:mt-[-2rem]', 'flex', 'flex-wrap', 'justify-center', 'md:justify-end', 'items-center', 'gap-4')}
          >
            {/* <a
              href="https://www.upwork.com"
              target="_blank"
              rel="noreferrer"
              className={cn('group', 'inline-flex', 'items-center', 'gap-3', 'rounded-full', 'border', 'border-border/60', 'bg-card/50', 'px-5', 'py-2.5', 'backdrop-blur-sm', 'transition-all', 'hover:border-[#14a800]/50', 'hover:bg-[#14a800]/5')}
            >
              <div className="flex items-center gap-1.5 text-[#14a800]">
                <svg className="h-5 w-5 fill-current" viewBox="0 0 24 24">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                </svg>
                <span className="text-sm font-extrabold tracking-tight">Top Rated</span>
              </div>
              <div className="h-4 w-px bg-border/80"></div>
              <span className="text-sm font-medium text-foreground/80 transition-colors group-hover:text-foreground">
                Hire us on Upwork
              </span>
              <ArrowUpRight className="h-3.5 w-3.5 text-foreground/50 transition-all group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:text-foreground" />
            </a> */}

            <a
              href="#contact"
              className={cn('group', 'inline-flex', 'items-center', 'gap-2', 'rounded-full', 'bg-brand', 'px-7', 'py-3.5', 'text-sm', 'font-semibold', 'text-brand-foreground', 'shadow-[0_12px_30px_-12px_var(--color-brand)]', 'transition', 'hover:opacity-90')}
              onClick={() => openCalendly()}
            >
              Book a Free 30-Min Discovery Call
              <ArrowRight className={cn('h-4', 'w-4', 'transition', 'group-hover:translate-x-0.5')} />
            </a>
            {/* <Link
              to="/workflowautomation"
              className={cn('nav-underline', 'inline-flex', 'items-center', 'gap-2', 'px-2', 'py-3.5', 'text-sm', 'font-semibold', 'text-foreground')}
            >
              Explore Our Work →
            </Link> */}
          </motion.div>


        </div>
        <div className={cn('mx-auto', 'px-4', 'md:px-14')}>
          <div
            className={cn('mt-10', 'md:mt-16', 'overflow-hidden')}
          >
            <div className={cn('trust-marquee', 'relative', 'w-full')}>
              <div className={cn('trust-marquee-track', 'flex', 'w-max', 'gap-12', 'md:gap-24', 'px-4', 'md:px-12')}>
                {[...trust, ...trust].map((t, idx) => {
                  const [n, ...rest] = t.split(" ");
                  return (
                    <div
                      key={`${t}-${idx}`}
                      className={cn('flex', 'items-center', 'md:items-end', 'gap-3', 'shrink-0')}
                    >
                      <div className={cn('font-sans', 'text-3xl', 'md:text-4xl', 'font-semibold', 'text-foreground')}>{n}</div>
                      <div className={cn('mt-1', 'text-xs', 'font-medium', 'uppercase', 'tracking-[0.16em]', 'text-foreground/75', 'w-24', 'md:w-28', 'leading-relaxed')}>
                        {rest.join(" ")}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <Suspense fallback={<div className={cn('min-h-screen', 'bg-background')} />}>
        <HeroBelowFold openCalendly={openCalendly} />
      </Suspense>
    </>
  );
}
